import validator from 'validator';
import moment from 'moment';

// Helpers
export const propertyInObject = (obj, property) => {
  if (obj[property]) {
    return true;
  }
  return false;
};

export const requiredField = (formValues, errorObj, field, message) => {
  const error = errorObj;
  if (!propertyInObject(formValues, field)) {
    error[field] = message;
  }
  return error;
};

export const emailField = (formValues, errorObj, field, message) => {
  const error = errorObj;
  if (formValues[field] && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues[field])) {
    error[field] = message;
  }
  return error;
};

export const urlField = (formValues, errorObj, field, message) => {
  const error = errorObj;
  if (formValues[field] && !validator.isURL(formValues[field])) {
    error[field] = message;
  }
  return error;
};

export const compareField = (formValues, errorObj, field, field1, message) => {
  const error = errorObj;
  if (formValues[field] !== formValues[field1]) {
    error[field] = message;
  }
  return error;
};

export const numberField = limit => {
  return (value, previousValue) => {
    if (!limit) {
      return validator.isNumeric(value) || value === '' ? value : previousValue;
    }
    return (value.length <= limit && validator.isNumeric(value)) || value === ''
      ? value
      : previousValue;
  };
};

export const minValue = (formValues, errorObj, field, min, message) => {
  const error = errorObj;
  if (parseInt(formValues[field], 10) < parseInt(min, 10)) {
    error[field] = message;
  }
  return error;
};

export const maxValue = (formValues, errorObj, field, min, message) => {
  const error = errorObj;
  if (parseInt(formValues[field], 10) > parseInt(min, 10)) {
    error[field] = message;
  }
  return error;
};

export const minLength = (formValues, errorObj, field, min, message) => {
  const error = errorObj;
  if (formValues[field] !== undefined && formValues[field].length < min) {
    error[field] = message;
  }
  return error;
};

export const maxLength = (formValues, errorObj, field, max, message) => {
  const error = errorObj;
  if (formValues[field] !== undefined && formValues[field].length > max) {
    error[field] = message;
  }
  return error;
};

export const minTime = (formValues, errorObj, startTime, endTime, startDate, endDate, message) => {
  const error = errorObj;

  const start_date = `${moment(formValues[startDate]).format('YYYY-MM-DD')}T${moment(
    moment.utc(formValues[startTime])
  ).format('HH:mm:ssZ')}`;

  const end_date = `${moment(formValues[endDate]).format('YYYY-MM-DD')}T${moment(
    moment.utc(formValues[endTime])
  ).format('HH:mm:ssZ')}`;

  if (moment.utc(end_date).isSameOrBefore(moment.utc(start_date))) {
    error[endTime] = message;
  }

  return error;
};

export const dateAfterValidation = (formValues, errorObj, date, message) => {
  const error = errorObj;

  if (!formValues[date]) {
    error[date] = message;
  }

  return error;
};
